/* eslint-disable react/prop-types */

import React, {useState, useReducer} from "react";

import { AiOutlineUser } from 'react-icons/ai'
import { HiMinusSm, HiPlusSm } from "react-icons/hi";

import { ModalApp } from "components/Modal";
import Button from "components/Button";

import { ContentRoom } from "./styles";

import { useApp } from "contexts/AppContext";
import { GuestsReducer } from "contexts/reducers/guests/reducers";
import { addAction, removeAction, increaseAgeAction, decreaseAgeAction } from "contexts/reducers/guests/actions";
import { changeGuestsAction, setTravellersHotelAction } from "contexts/reducers/hotels/actions";

export default function RoomQuantity() {

    const { hotelState, hotelDispatch } = useApp()
    const { guestsSearchHotel, travellers } = hotelState

    const INITIAL_STATE_GUEST = {
        adults: guestsSearchHotel?.adults,
        children: guestsSearchHotel?.children,
        childrenInputAge: guestsSearchHotel?.childrenInputAge
    }

    const [open, setOpen] = useState(false);
    const [dataTravellers, setDataTravellers] = useState(travellers)


    const [guestsState, dispatch] = useReducer(
        GuestsReducer,
        INITIAL_STATE_GUEST
    )

    const { adults, children, childrenInputAge } = guestsState

    const add = (type) => {
        setDataTravellers([...dataTravellers, {
            "type": type,
            "firstName": "",
            "lastName": "",
            "birthDate": "",
            "gender": "",
            "document": ""
        }])
        dispatch(addAction(type))
    }

    const remove = (type) => {
        if(dataTravellers.length === 1) {
            return
        }

        setDataTravellers([...dataTravellers.filter((_,index) => index !== 0)])
        dispatch(removeAction(type))
    }

    const increaseAge = (position) => {
        dispatch(increaseAgeAction(position))
    }

    const decreaseAge = (position) => {
        dispatch(decreaseAgeAction(position))
    }

    const handleModal = () => {
        hotelDispatch(changeGuestsAction(guestsState))
        hotelDispatch(setTravellersHotelAction(dataTravellers))

        setOpen(!open);
    };

    const InputControl = ({type, placeholder, value = null}) => {
        return (
            <div className="input-group">
                <label className="label-custom">{placeholder}</label>
                <span className="input-group-custom">
                    <span className="px-1" role="button"
                          onClick={() => remove(type)}>
                        <HiMinusSm/>
                    </span>
                </span>
                <span className="input-group-custom px-0">{value}</span>
                <span className="input-group-custom">
                   <span className="px-1" role="button"
                         onClick={() => add(type)}>
                        <HiPlusSm/>
                    </span>
                </span>
            </div>
        )
    }

    const InputControlAge = ({ placeholder, value = null, position}) => {
        return (
            <div className="input-group flex-nowrap">
                <label className="label-custom text-nowrap">{placeholder}</label>
                <span className="input-group-custom">
                    <span className="px-1" role="button"
                          onClick={() => decreaseAge(position) }>
                        <HiMinusSm/>
                    </span>
                </span>
                <span className="input-group-custom px-0">{value}</span>
                <span className="input-group-custom">
                   <span className="px-1" role="button"
                         onClick={() => increaseAge(position)}>
                        <HiPlusSm/>
                    </span>
                </span>
            </div>
        )
    }

    return (
        <div className="content-custom">
            <div className="input-group" onClick={handleModal}>
                <label className="d-flex flex-grow-1 label-custom">Hóspedes</label>

                <span className="input-group-custom d-flex align-items-center gap-2 pe-0">
                    { adults + children } <AiOutlineUser/>
                </span>

            </div>

            <ModalApp show={open} handleModal={handleModal}>

                <ContentRoom className="px-4 pt-5">
                    <div className="row">
                        <div className="col d-grid gap-4">

                            <InputControl placeholder="Adultos" type="adults" value={adults} />
                            <InputControl placeholder="Crianças" type="children" value={children} />

                            <div className="row">

                                { childrenInputAge?.length > 0 &&
                                    <div className="mb-3 text-start text-muted">
                                        <small>*idade da data que será feito o check-in.</small>
                                    </div>
                                }

                                { childrenInputAge?.length > 0 && childrenInputAge.map((item, i) =>

                                    <div className="col-6 mb-3" key={i}>
                                        <InputControlAge
                                            placeholder={`Criança ${i + 1}`}
                                            value={item.age}
                                            position={i}
                                        />
                                    </div>

                                )}
                            </div>
                        </div>
                    </div>

                    <div className="mt-4 d-flex justify-content-center">
                        <Button type="button" width="200px" onClick={ handleModal }>CONTINUAR</Button>
                    </div>
                </ContentRoom>
            </ModalApp>
        </div>
    );
}
